import { PitcherSingleSessionReportChartConfigDto, PitcherStatsByPitchType, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const disabledVisibleStats: (keyof PitcherStatsByPitchType)[] = ['pitchType'];

const PitcherSingleSessionStatsByPitchTypeChartSidebar = (
  props: ChartConfigProps<TableChartConfigDto, PitcherSingleSessionReportChartConfigDto>
) => {
  return (
    <TableChartSidebar
      chartId='PitcherSingleSessionStatsByPitchTypeChart'
      configKey='pitcherSingleSessionStatsByPitchTypeChartConfig'
      disabledVisibleStats={disabledVisibleStats}
      {...props}
    />
  );
};

export default PitcherSingleSessionStatsByPitchTypeChartSidebar;
